import moment from 'moment';
import uuid from 'uuid';
import { datePickerFormat, FlightRequestFormLeg } from './flightRequestFormMapper';

export function defaultLeg(): FlightRequestFormLeg {
    return {
        id: uuid.v4(),
        departureAirport: null,
        departureLocation: null,
        arrivalAirport: null,
        arrivalLocation: null,
        date: '',
        useDepartureDate: true,
        time: '',
        passengers: 1,
        specialRequests: '',
        isExpanded: true,
        showValidationErrors: false
    };
}
